import {t} from "@/hooks/web/useI18n";

export default  [
  {
    path: '/go-app-rocket-show/msgPages/newsErrorLog',
    name: 'newsErrorLog',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('错误日志'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/go-app-rocket-show/msgPages/newsErrorLog.vue'),
  },
  {
    path: '/systemMainPage',
    name: 'systemMainPage',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('系统门户设置'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/systemMainPage/index.vue'),
  },
  {
    path: '/groupMainPage',
    name: 'groupMainPage',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('集团门户设置'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/groupMainPage/index.vue'),
  },
  {
    path: '/unitAdminPage',
    name: 'unitAdminPage',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('管理员门户设置'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/unitAdminPage/index.vue'),
  },
  {
    path: '/agentAdminPage',
    name: 'agentAdminPage',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('代理门户设置'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/agentAdminPage/index.vue'),
  },
  {
    path: '/operateAdminPage',
    name: 'operateAdminPage',
    meta: {
      orderNo: 10,
      icon: 'ion:grid-outline',
      title: t('平台运营门户'),
    },
    component: () => import(/* webpackChunkName: "org" */'@/views/operate-admin-page/index.vue'),
  }
]
